import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "funnel",
  "use": "funnel-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"funnel\"><path d=\"M19 30l-6-4.5v-9.16L2 2h28L19 16.34zm-4-5.5l2 1.5V15.66L26 4H6l9 11.66z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/funnel.svg
// module id = q58C
// module chunks = 39 44